module.exports = __webpack_public_path__ + "static/media/Img-01.0bd66501.jpg";